// utils/priceFormatter.js

export const formatPrice = (price) => {
    if (!isNaN(price)) {
        // Formats to currency with commas for thousands, millions, etc.
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price);
    }
    return "N/A";
};
